import yash_image from './asset/yash.jpg';

const Header_data = {
  image: {
    alt: 'yash_datir',
    src: yash_image,
    style: { width: '210px', height: '200px' }
  },
  heading: { name: 'Yash Ajay Datir', sub_text: 'B.E. Computer Engineering' },
  card: {
    heading: 'Projects and Achievements',
    data: [
      {
        info: {
          heading: 'Robocon 2018',
          body:
            'Core Programmer, also won the best Rookie award and 10k cash prize from IIT(D) in the Robocon 2018 nationals held at Balewadi stadium, Pune, Maharashtra',
          link: 'https://neotech.ac.in/'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'E - Vendor System',
          body:
            'The project was for the company during my internship in the IS department @ Gujarat Refinary - Indian Oil Corporation, Vadodara, Gujarat',
          link: 'https://iocl.com/AboutUs/GujaratRefinery.aspx'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(-5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'BMS system with HVAC',
          body:
            'The DE project for the year 2016-17, the Building management system design and implementation for the college project.',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Industrial Software Solution',
          body:
            'The DE project for the year 2017-18, the Industrial Software Solution with SAP and realtime data monitoring and integration solution for college project.',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(-5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Web Host Console',
          body:
            'The project was for the company during my internship as Jr. Programmer @ Ruby Infotech, Vadodara, Gujarat',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Rentickle',
          body:
            'Rentickle is an E-Com application deals with renting and sales of mainly furniture and related items. It has highly optimised search and select feature combined with UI, gives great experience to the user. ',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(-5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Knack',
          body:
            'Knack is fully integrated enterprise management tool for self employed professionals. Using Knack one can, Book and manage client appointments, Enhance client engagement, Manage earnings, Enable online payment and Track client activities.',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Intranet',
          body:
            'Intranet is the solution implemented within the organization that helped in maintaining the information and execution of day to day operations online.',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(-5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'E-Exam(Assessment)',
          body:
            'Assessment is a online evaluation platform for Teacher and students that helps schools in making the evaluation process very convenient.',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Online Acadzy',
          body:
            'Created POC(s) with ElectronJS, ZoomSDK for video assisted teaching.',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(-5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Madly',
          body: 'On It...',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      },
      {
        info: {
          heading: 'Coming Soon...',
          body: '',
          link: '#'
        },
        style: {
          marginTop: '20px',
          transform: 'skewY(-5deg)',
          height: '250px',
          width: '200px',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
      }
    ]
  }
};
const Body_data = {
  modal: {
    heading: 'Welcome to my official page',
    body_info: 'This is the Modal body data'
  },
  heading: 'About Me',
  about: {
    email: 'yashdatir@gmail.com',
    phone: '+91 7990097420',
    gender: 'Male',
    hometown: {
      place: 'Vadodara, Gujarat',
      link:
        'https://www.google.com/maps/place/Visa+Court,+Shreeji+Society,+Sukrutinagar,+Diwalipura,+Vadodara,+Gujarat+390007/@22.2957698,73.1596467,17z/data=!3m1!4b1!4m5!3m4!1s0x395fc61e310c1ee5:0x4d0f5c249ac25004!8m2!3d22.2957698!4d73.1618354'
    },
    current: {
      place: 'Ahmedabad, Gujarat',
      link: 'https://goo.gl/maps/RX872LNvbM4aLh8H8'
    },
    current1: {
      place: 'Bengaluru, Karnataka',
      link:
        'https://www.google.com/maps/place/496,+KHB+Colony,+5th+Block,+Koramangala,+Bengaluru,+Karnataka+560095/@12.9339423,77.6184132,19z/data=!3m1!4b1!4m13!1m7!3m6!1s0x3bae1670c9b44e6d:0xf8dfc3e8517e4fe0!2sBengaluru,+Karnataka!3b1!8m2!3d12.9715987!4d77.5945627!3m4!1s0x3bae1450065d8f1f:0xdea309025dcef50c!8m2!3d12.9339423!4d77.6189604'
    },
    nationality: 'Indian'
  },
  school: {
    heading: 'Schools and Academic',
    list_school: [
      {
        year: '2003-2008',
        school:
          'Gujarat Refinary English Medium School, Jawaharnagar, Vadodara',
        course: 'class: V',
        class: 'container_t left'
      },
      {
        year: '2008-2012',
        school: 'Delhi Public School, Panipat Refinary, Panipat, Haryana',
        course: 'class: IX',
        class: 'container_t right'
      },
      {
        year: '2012-2014',
        school:
          'Gujarat Refinary English Medium School, Jawaharnagar, Vadodara',
        course: 'SSC',
        class: 'container_t left'
      },
      {
        year: '2014-2016',
        school: 'Tejas Vidyalaya, Ellorapark, Vadodara',
        course: 'HSC',
        class: 'container_t right'
      },
      {
        year: '2016-2020',
        school: 'Neotech Technical Campus',
        course: 'BE',
        class: 'container_t left'
      },
      {
        year: '2020-2021',
        school: 'Xelpmoc Design and Tech',
        course: 'Jr. Software Developer',
        class: 'container_t right'
      },
      {
        year: '2021-now',
        school: 'IntellimediaNetworks',
        course: 'Fullstack Developer',
        class: 'container_t left'
      }
    ]
  },
  certifications: {
    heading: 'My Certifications',
    extra: [
      {
        organization: 'ITM Universe, Vadodara',
        course: 'Robotics workshop',
        remarks: 'na',
        dated: '16/05/2016'
      },
      {
        organization: 'MSU, Baroda',
        course: 'Startupedia event',
        remarks: 'na',
        dated: '2016'
      },
      {
        organization: 'MSU, Baroda',
        course: 'talk by JJ Rawal on Our wonderful universe',
        remarks: 'na',
        dated: '06/10/2016'
      },
      {
        organization: 'NTC, vadodara',
        course: 'Hunting in C',
        remarks: 'na',
        dated: '18/02/2017'
      },
      {
        organization: 'NTC, Vadodara',
        course: 'Roborace',
        remarks: 'na',
        dated: '19/02/2017'
      },
      {
        organization: 'IIT, Kanpur',
        course: 'Techriti-17: workshop on IoT ',
        remarks: 'na',
        dated: '2017'
      },
      {
        organization: 'Arjun Sharma, ADDROPE TECHNOLOGIES',
        course: 'Workshop on Ethical hacking',
        remarks: 'na',
        dated: '29/10/2017'
      },
      {
        organization: 'ABU-Robocon 2018 Nationals',
        course: 'Robocon contest @ Pune',
        remarks: 'Best Rookie Award',
        dated: '1-3/05/2018'
      },
      {
        organization: 'TOPS Technologies',
        course: 'workshop on ReactJS',
        remarks: 'na',
        dated: '25/05/2019'
      }
    ],
    professional: [
      {
        organization: 'IIHT, Vadodara',
        course: 'Netorking',
        remarks: 'A',
        dated: '22/07/2016'
      },
      {
        organization: 'Redhat system',
        course: 'System Administration 124, 134, 254',
        remarks: '-',
        dated: '25/5/2016'
      },
      {
        organization: 'IIHT, Vadodara',
        course: 'RHCE',
        remarks: 'A',
        dated: '22/07/2016'
      },
      {
        organization: 'IIHT, Vadodara',
        course: 'Programming in C',
        remarks: 'A',
        dated: '01/03/2017'
      },
      {
        organization: 'IIHT, Vadodara',
        course: 'Programming in C++',
        remarks: 'A',
        dated: '01/11/2017'
      },
      {
        organization: 'IIHT, Vadodara',
        course: 'Programming in Core Java',
        remarks: 'A',
        dated: '27/08/2018'
      },
      {
        organization: 'IIHT, Vadodara',
        course: 'Programming in Advance Java',
        remarks: 'A',
        dated: '29/01/2019'
      }
    ],
    academics: [
      {
        school: 'GREMS, Baroda',
        board: 'Gujarat Secondary Education Board',
        course: 'SSC',
        marks: ''
      },
      {
        school: 'Tejas Vidyalaya, Baroda',
        board: 'Gujarat Secondary and Higher Secondary Education Board',
        course: 'HSC',
        marks: ''
      },
      {
        school: 'Neotech Institute of Technology',
        board: 'Gujarat Technological University',
        course: 'BE',
        marks: ''
      }
    ],
    internship: [
      {
        company: 'Indian Oil Coorporation Ltd.',
        technology: 'JSP, .Net, MySQL',
        dates: ''
      },
      {
        company: 'Ruby Infotech, Vadodara',
        technology: 'JSP, Javascript, MySQL',
        dates: ''
      },
      {
        company: 'XELPMOC Design and Tech',
        technology: 'ReactJS, NodeJS(MERN), MySQL',
        dates: ''
      }
    ]
  },
  other_involvements: {
    heading: 'My Other Involvements',
    list: [
      { text: 'Sri Ramakrishna Mission, Vadodara' },
      //   { text: 'Gujarat state Police(Vadodara City Cyber volunteer), Vadodara' },
      { text: "The Baroda Book Browser's Association, Vadodara" },
      { text: 'Sri Lakshmidevi Park - Library member, Koramangala, Bengaluru' }
    ]
  }
};

export { Header_data, Body_data };
